<template>
  <component :is="layout">
    <transition mode="out-in">
      <router-view @layout="layout = $event" />
    </transition>
    <!--
      TODO
      シーズンコンポーネントのファクトリを作成して、そこで時期に応じて
      作成するコンポーネントを変えるようにすれば良さそう。
      -->
    <snow-fall v-if="enableSeasonFeature" />
  </component>
</template>

<script>
import SnowFall from '@/components/season_feature/SnowFall.vue'

export default {
  components: { SnowFall },
  data() {
    return {
      layout: 'div',
    }
  },
  computed: {
    enableSeasonFeature() {
      return this.$store.state.preferences.enableSeasonFeature
    },
  },
}
</script>

<style lang="scss">
.no-select {
  user-select: none;
}
</style>

<style lang="scss" scoped>
// Router Transition Animation
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
